import React from "react";
import PropTypes from "prop-types";
import styles from "./AppListItem.module.css";
import groupIcon from "../../assets/Move_Handle.svg";
import { Draggable } from "react-beautiful-dnd";

export function AppListItem({ app, index }) {
  return (
    <Draggable key={app.id} draggableId={app.id} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={`${styles.item} ${
            snapshot.isDragging ? styles.dragging : ""
          }`}
          style={provided.draggableProps.style}
        >
          <div className={styles.name}>{app.name}</div>

          <img src={groupIcon} alt="Group Icon" className={styles.groupIcon} />
        </div>
      )}
    </Draggable>
  );
}

AppListItem.propTypes = {
  app: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),

  //Represents the the position of th eitem in the array
  index: PropTypes.number,
};
